import {FormControl, FormGroup} from '@angular/forms';
import {Partner} from '../models/partner';

export abstract class PartnerForm {
  static getCompany(): FormGroup {
    return new FormGroup({
      langs: new FormControl([]),
      country: new FormControl(''),
      address: new FormControl(''),
      zipCode: new FormControl(''),
      state: new FormControl(''),
      city: new FormControl(''),
      email: new FormControl(''),
      phoneNumber: new FormControl(''),
    });
  }

  static updateCompany(form: FormGroup, partner: Partner): void {
    form.patchValue({
      langs: partner.langs,
      country: partner.country,
      address: partner.address,
      zipCode: partner.zipCode,
      state: partner.state,
      city: partner.city,
      email: partner.email,
      phoneNumber: partner.phoneNumber,
    });
  }
  static getPayment(): FormGroup {
    return new FormGroup({
      accountHolder: new FormControl(),
      bankName: new FormControl(),
      bankAddress: new FormControl(),
      iban: new FormControl(),
      swift: new FormControl(),
      routingNumber: new FormControl(),
    });
  }

  static updatePayment(form: FormGroup, partner: Partner): void {
    form.patchValue({
      accountHolder: partner.accountHolder,
      bankName: partner.bankName,
      bankAddress: partner.bankAddress,
      iban: partner.iban,
      swift: partner.swift,
      routingNumber: partner.routingNumber,
    });
  }
}
